import { styled } from "@mui/material";

interface ComponentProps {
    MinYear: number;
    MaxYear: number;
    Score: number;
    RouteName: string;
}

const ScoreSetupDetails : React.FC<ComponentProps> = ({ Score, MinYear, MaxYear, RouteName }) => {
    return (
        <StyledContainer>
            <StyledWrapper>
                <StyledText>Score Type</StyledText>
                <Active>Hr and or Related Management Training Programme</Active>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Score</StyledText>
                <StyledDate> {Score}</StyledDate>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Year Range</StyledText>
                <StyledDate>{MinYear} - {MaxYear} Years</StyledDate>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Route</StyledText>
                <StyledDate>{RouteName}</StyledDate>
            </StyledWrapper>
            {/* <StyledWrapper>
                <StyledText2>Year Range</StyledText2>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>{MinYear} - {MaxYear} Years</StyledText>
            </StyledWrapper> */}
        </StyledContainer>
    )
}

export default ScoreSetupDetails;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
`
const StyledText2 = styled('span')`
    font-size: 24px;
    font-weight: 500;
    color: #020D08;
    width:100%
`

const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`